import { RsoListPage } from "@/features/rso/pages/RsoList";
import { RsoFilterCacheProvider } from "@/features/rso/provider/RsoListFilterCacheProvider";

const RsoList = () => {
  return (
    <RsoFilterCacheProvider>
      <RsoListPage />
    </RsoFilterCacheProvider>
  );
};

export default RsoList;
